<template>
    <div id="CalledCard" v-if="callSection == 'finished' || callSection == 'suite'">
        <div id="calledText">
            {{ winnerUser.name }}
        </div>
        <div  v-if="calledCard.length > 1">
            <img class="imgCard" :src="require('../assets/cards/' + table.card_type + '/' + calledCard + '.png')" width="100" height="180"/>
        </div>
        <div v-else>
            <Loader></Loader>
        </div>
        <div id="calledText" class="called-points">
            {{ calledPoints }}
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader";
import { mapGetters } from "vuex";

export default {
  name: "CallTable",
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      callSection: "call/callSection",
      calledCard: "call/calledCard",
      calledPoints: "call/calledPoints",
      winnerUser: "call/winnerUser",
      table: "tables/tableActive"
    })
  },
  data() {
    return {
      cardTime: true,
      pointTime: true
    };
  },
};
</script>
<style scoped>
#CalledCard {
    background: radial-gradient(
        circle,
        rgba(250, 250, 250, 1) 0%,
        rgba(32, 178, 170, 1) 94%
    );
    color: white;
    border: solid 3px black;
    border-radius: 25px;
    z-index: 10;
    width: 100%;
    padding: 2px;
    height: fit-content;
}
#calledText {
    border: 1px solid white;
    background-color: black; 
    color: antiquewhite;
    font-weight: 900;
    border-radius: 15px;
    margin:3px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
}

@media all and (max-height: 860px), (max-width: 870px){
  .imgCard {
    width: 70px;
    height: 130px;
  }
}
@media all and (max-height: 750px) {
  .imgCard {
    width: 60px;
    height: 110px;
  }
}
@media all and (max-height: 620px) { 
  .imgCard {
    width: 40px;
    height: 80px;
  }
}
@media all and (max-height: 500px) {
  .imgCard {
    width: 40px;
    height: 85px;
  }
  #calledText {
    margin: 0em;
    font-size: 13px;
    font-weight: 800;
  }
  .called-points {
    visibility: hidden;
  }
}

</style>
